import { createSlice } from "@reduxjs/toolkit";
import {
  addBusinessDays,
  YEAR_MONTH_DAY,
  YEAR_MONTH_DAY_2
} from "constants/date";
import moment from "moment";

const YES = "1";
const NO = "0";

// const tomorrowDate = addBusinessDays(new Date(), 1);
const tomorrowDate = moment().add(1, "day").format(YEAR_MONTH_DAY_2);

const initialState = {
  attendingWithAnother: "0",
  anotherNric: "",
  selectedDate: tomorrowDate,
  selectedService: {
    value: "",
    label: "",
    address: ""
  },
  selectedTimeSlot: {
    value: "",
    label: ""
  },
  anotherSelectedTimeSlot: {
    value: "",
    label: ""
  },
  selectedApptType: {
    value: "",
    label: ""
  },
  registeredAppointmentId: "",
  registeredApptTimeslotId: "",
  previousRouteName: "",
  captchaToken: "",
  displaySelectedDate: "",
  displaySelectedTime: "",
  displaySelectedService: {
    value: "",
    label: "",
    address: ""
  },
  defaultLocationId: "",
  bookingTxnId: ""
};

export const appointmentBookingSlice = createSlice({
  name: "appointmentBooking",
  initialState,
  reducers: {
    changeAttendingWithAnother: (state, action) => {
      state.attendingWithAnother = action.payload;
    },
    changeSelectedDate: (state, action) => {
      state.selectedDate = action.payload;
    },
    changeSelectedService: (state, action) => {
      state.selectedService = action.payload;
    },
    changeSelectedTimeSlot: (state, action) => {
      state.selectedTimeSlot = action.payload;
    },
    changeSelectedApptType: (state, action) => {
      state.selectedApptType = action.payload;
    },
    clearAppointmentBooking: (state) => {
      state.attendingWithAnother = "0";
      state.selectedDate = tomorrowDate;
      state.selectedService = {
        value: "",
        label: "",
        address: ""
      };
      state.selectedTimeSlot = {
        value: "",
        label: ""
      };
      state.selectedApptType = {
        value: "",
        label: ""
      };
      state.anotherSelectedTimeSlot = {
        value: "",
        label: ""
      };
      state.anotherNric = "";
      state.previousRouteName = "/service";
      state.captchaToken = "";
      state.displaySelectedDate = "";
      state.displaySelectedTime = "";
      state.registeredAppointmentId = "";
      state.registeredApptTimeslotId = "";
      state.displaySelectedService = {
        value: "",
        label: "",
        address: ""
      };
      state.bookingTxnId = "";
    },
    changeRegisteredAppointmentId: (state, action) => {
      state.registeredAppointmentId = action.payload;
    },
    changeRegisteredApptTimeslotId: (state, action) => {
      state.registeredApptTimeslotId = action.payload;
    },
    updateAppointmentBookingInfo: (state, action) => {
      const {
        id,
        date,
        service_center,
        address_text,
        live_appt_timeslot_id,
        schedule_dt,
        appt_type_id,
        service_id,
        another_person_identity,
        attending_with_another_person,
        booking_txn_id,
        default_location_id,
        appointment_type_text,
        appt_type_code
      } = action.payload;
      state.selectedApptType = {
        value: appt_type_id,
        label: appointment_type_text,
        code: appt_type_code
      };
      state.registeredAppointmentId = id;
      state.registeredApptTimeslotId = live_appt_timeslot_id;
      state.displaySelectedDate = moment(date).format(YEAR_MONTH_DAY);
      state.displaySelectedTime = schedule_dt;
      state.displaySelectedService = {
        value: service_id,
        label: service_center,
        address: address_text
      };
      state.anotherNric = another_person_identity;
      state.attendingWithAnother = attending_with_another_person ? YES : NO;
      state.bookingTxnId = booking_txn_id;
      state.defaultLocationId = default_location_id;
    },
    changePreviousRouteName: (state, action) => {
      state.previousRouteName = action.payload;
    },
    changeCaptchaToken: (state, action) => {
      state.captchaToken = action.payload;
    },
    changeDisplaySelectedDate: (state, action) => {
      state.displaySelectedDate = action.payload;
    },
    changeDisplaySelectedTime: (state, action) => {
      state.displaySelectedTime = action.payload;
    },
    changeDisplaySelectedService: (state, action) => {
      state.displaySelectedService = action.payload;
    },
    changeAnotherNric: (state, action) => {
      state.anotherNric = action.payload;
    },
    changeAnotherSelectedTimeSlot: (state, action) => {
      state.anotherSelectedTimeSlot = action.payload;
    },
    changeDefaultLocationId: (state, action) => {
      state.defaultLocationId = action.payload;
    },
    changeBookingTxnId: (state, action) => {
      state.bookingTxnId = action.payload;
    },
    changeTransTime: (state, action) => {
      state.transTime = action.payload;
    }
  }
});

export const {
  changeAttendingWithAnother,
  changeSelectedDate,
  changeSelectedService,
  changeSelectedTimeSlot,
  changeSelectedApptType,
  clearAppointmentBooking,
  changeRegisteredAppointmentId,
  changeRegisteredApptTimeslotId,
  updateAppointmentBookingInfo,
  changePreviousRouteName,
  changeCaptchaToken,
  changeDisplaySelectedDate,
  changeDisplaySelectedTime,
  changeDisplaySelectedService,
  changeAnotherNric,
  changeAnotherSelectedTimeSlot,
  changeDefaultLocationId,
  changeBookingTxnId,
  changeTransTime
} = appointmentBookingSlice.actions;

export default appointmentBookingSlice.reducer;
